import React from 'react'
import PicCont from './PicCont';
import Button from './Button';
import * as gtag from '../lib/gtag'
import QuotePop from './DeferredQuotePopup';
import { AiOutlinePhone } from "@react-icons/all-files/ai/AiOutlinePhone";
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_POPUP } from '../store/slices/ui';

const BGBlock = ({ picture, title, par, buttons, children, src, className, position, loading, priority }) => {
    let dispatch = useDispatch()


  return    <div data-msr-surface='dark' className={`bgBlock ${className}`}>
  <PicCont loading={loading} priority={priority} position={position} background src={src} />
  <div className="back"></div>
  <div className="textBox">
      <div className='text'>

        {children }

        {buttons &&  <div className='buttons'>
              <Button className='btn-4 highLight ' onClick={() => dispatch(SHOW_POPUP({key: 'quote', size: 'medium', body: <QuotePop />}))} >Get a Quote</Button>
              <a className='btn-4 highLight  button' href="tel:+13059744411" onClick={() => gtag.event({ action:  'booking_assistance_call', label: 'leads', value: 20, category: 'orders' })}><AiOutlinePhone /> (305) 974-4411</a>
          </div>}
      </div>
  </div>
</div>


}

export default BGBlock
